import { Outlet } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'
import Sidebar from './Sidebar'
import MobileNav from './MobileNav'
import Header from './Header'
import NotificationCenter from './NotificationCenter'

const ErrorFallback = ({ error, resetErrorBoundary }) => (
  <div className="p-6 bg-red-50 border border-red-200 rounded-lg">
    <div className="text-red-700 font-semibold mb-2">Ops! Algo deu errado.</div>
    <div className="text-red-600 text-sm mb-4">{error?.message || 'Erro inesperado ao renderizar a página.'}</div>
    <button onClick={resetErrorBoundary} className="btn-secondary">Tentar novamente</button>
  </div>
)

const Layout = () => {
  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar para desktop */}
      <div className="hidden lg:flex lg:flex-shrink-0">
        <Sidebar />
      </div>

      {/* Conteúdo principal */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        
        <main className="flex-1 overflow-y-auto">
          <div className="p-4 lg:p-6">
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              <Outlet />
            </ErrorBoundary>
          </div>
        </main>
      </div>

      {/* Navegação mobile */}
      <div className="lg:hidden">
        <MobileNav />
      </div>

      {/* Centro de notificações */}
      <NotificationCenter />
    </div>
  )
}

export default Layout